<template>
  <div class="cases-page">
    <!-- 头部 -->
    <AppHeader />

    <!-- Banner -->
    <div class="banner" :style="{ backgroundImage: 'url(' + bannerImage + ')' }"></div>

    <!-- 悦享超级卡 -->
    <section class="section supercard-section">
      <div class="container">
        <div class="supercard-wrapper">
          <div class="supercard-image">
            <img src="//34188381.s21i.faiusr.com/2/ABUIABACGAAg6fqlzwYoxbGEqAEwrQU4oQg.jpg" alt="悦享超级卡">
          </div>
          <div class="supercard-content">
            <h2 class="supercard-title">悦享超级卡</h2>
            <div class="supercard-desc">
              <p>
                支持兑换全国 <span class="highlight-red">600＋</span> 城市 <span
                  class="highlight-red">16000＋</span>影院，实时更新全国热映，知名院线主流视听
              </p>
            </div>
            <div class="supercard-features">
              <h3>产品特点</h3>
              <p>使用方式：储值类点卡，使用卡内点数兑换悦影时光福利商品；</p>
              <p>功能属性：充值、查询、兑换、多卡合并支付等功能；</p>
            </div>
          </div>
        </div>
      </div>
    </section>
<!-- 服务项目 -->
    <section class="section service-items-section">
      <div class="container">
        <div class="section-label">Service Items</div>
        <h2 class="section-heading">服务项目</h2>

        <div class="service-items-grid">
          <div class="service-item">
            <div class="service-item-img">
              <img src="//34188381.s21i.faiusr.com/4/ABUIABAEGAAg1YS7zwYo-v7rrQIwzAQ4jgk!500x500.png" alt="电影频道">
            </div>
            <div class="service-item-content">
              <h3 class="service-item-name">电影频道</h3>
              <p class="service-item-desc">支持兑换全国600+城市16000+影院，实时更新全国热映，知名院线主流视听</p>
            </div>
          </div>
          <div class="service-item">
            <div class="service-item-img">
              <img src="//34188381.s21i.faiusr.com/4/ABUIABAEGAAg0YS7zwYomqCBcjCABDj2Bw!500x500.png" alt="文娱会员">
            </div>
            <div class="service-item-content">
              <h3 class="service-item-name">文娱会员</h3>
              <p class="service-item-desc">包括视频、阅读、音乐、网络工具四个场景类型，63个主流品牌，277款年、季、月会员</p>
            </div>
          </div>
          <div class="service-item">
            <div class="service-item-img">
              <img src="//34188381.s21i.faiusr.com/4/ABUIABAEGAAgzIS7zwYorOHTqwEwgAQ49gc!500x500.png" alt="演出频道">
            </div>
            <div class="service-item-content">
              <h3 class="service-item-name">演出频道</h3>
              <p class="service-item-desc">音乐会/话剧/戏曲/赛事杂技/亲子儿童等场馆门票及VIP席位，在线选票，安全便捷让您享受足不出户的一站式娱乐购票方式。</p>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- 合作影城 -->
    <section class="section cinema-section">
      <div class="container">
        <div class="section-label">Cooperative Movie City</div>
        <h2 class="section-heading">合作影城</h2>
        <div class="cinema-logos">
          <img src="../src/assets/dyy.png" alt="合作影城">
        </div>
      </div>
    </section>

    
<ComsPross />
    <!-- 福利卡使用流程 -->
    <!-- <section class="section process-section">
      <div class="container">
        <div class="section-label">Using Processes</div>
        <h2 class="section-heading">福利卡使用流程</h2>

        <div class="process-steps">
          <div class="process-item">
            <div class="process-card">
              <img class="process-icon" src="../src/assets/1.png" alt="关注公众号">
            </div>
            <div class="process-item-text">
              <div class="process-name">关注公众号</div>
              <div class="process-desc">关注微信公众号"悦享聚汇"，选择【悦影时光】板块</div>
            </div>
          </div>
          <div class="process-arrow">›</div>
          <div class="process-item">
            <div class="process-card">
              <img class="process-icon" src="../src/assets/2.png" alt="进入悦影时光">
            </div>
            <div class="process-item-text">
              <div class="process-name">进入悦影时光</div>
              <div class="process-desc">进入悦影时光登陆账号，选择福利卡进行绑定</div>
            </div>
          </div>
          <div class="process-arrow">›</div>
          <div class="process-item">
            <div class="process-card">
              <img class="process-icon" src="../src/assets/3.png" alt="绑定福利卡">
            </div>
            <div class="process-item-text">
              <div class="process-name">绑定福利卡</div>
              <div class="process-desc">输入卡号、密码或扫描二维码完成电影卡的绑定</div>
            </div>
          </div>
          <div class="process-arrow">›</div>
          <div class="process-item">
            <div class="process-card">
              <img class="process-icon" src="../src/assets/4.png" alt="选择心仪商品">
            </div>
            <div class="process-item-text">
              <div class="process-name">选择心仪商品</div>
              <div class="process-desc">选择商品加入购物车进行下单，可通过我的订单查询信息</div>
            </div>
          </div>
        </div>
      </div>
    </section> -->

    <!-- 底部 -->
    <AppFooter />
  </div>
</template>

<script>
import AppHeader from '@/components/head.vue'
import AppFooter from '@/components/foot.vue'
import ComsPross from '@/components/coms2.vue';
export default {
  name: 'Cases',
  components: {
    AppHeader,
    AppFooter,ComsPross
   
  },
  data() {
    return {
      bannerImage: require('../src/assets/dy.png'),
      footerNavItems: ['关于我们', '福利优选', '年节礼包', '生日卡券', '电影演出', '悦动态']
    }
  }
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: 'Microsoft YaHei', 'PingFang SC', sans-serif;
  color: #353535;
  line-height: 1.6;
}

.cases-page {
  background: #fff;
}

/* Banner */
.banner {
  height: 800px;
  background-size: cover;
  background-position: 50% 50%;
}

/* 通用 */
.section {
  padding: 60px 0;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.section-label {
  text-align: center;
  color: #e5e5e5;
  font-size: 36px;
  font-weight: bold;
}

.section-heading {
  text-align: center;
  color: #353535;
  font-size: 36px;
  font-weight: bold;
  margin-bottom: 50px;
}

/* 悦享超级卡 */
.supercard-wrapper {
  display: flex;
  gap: 30px;
  align-items: flex-start;
}

.supercard-image {
  flex: 0 0 auto;
}

.supercard-image img {
  width: 200px;
  border-radius: 4px;
}

.supercard-content {
  flex: 1;
  text-align: left;
  min-width: 0;
}

.supercard-title {
  font-size: 28px;
  color: #353535;
  margin-bottom: 10px;
  padding-top: 0;
}

.supercard-desc {
  text-align: left;
  font-size: 20px;
  line-height: 2em;
  color: #666;
  margin-bottom: 10px;
}

.highlight-red {
  color: #FF0036;
  font-weight: bold;
}

.supercard-features {
  font-size: 20px;
  line-height: 2em;
  color: #666;
}

.supercard-features h3 {
  font-size: 20px;
  color: #353535;
  margin-bottom: 10px;
}

/* 合作影城 */
.cinema-logos {
  text-align: center;
}

.cinema-logos img {
  max-width: 100%;
  height: auto;
}

/* 服务项目 */
.service-items-grid {
  display: flex;
  gap: 50px;
  margin-top: 50px;
}

.service-item {
  flex: 1;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.service-item-img {
  width: 250px;
  margin: 0 auto 50px;
}

.service-item-img img {
  width: 100%;
  border-radius: 4px;
}

.service-item-content {
  width: 100%;
  max-width: 300px;
}

.service-item-name {
  font-size: 20px;
  color: #353535;
  margin-bottom: 10px;
}

.service-item-desc {
  font-size: 12px;
  color: #636363;
  line-height: 1.8;
  word-break: break-word;
}

/* 福利卡使用流程 */
.process-steps {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  gap: 0;
  margin-top: 50px;
}

.process-item {
  text-align: center;
  width: 25%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.process-card {
  width: 125px;
  height: 125px;
  margin: 0 auto 30px;
  flex-shrink: 0;
}

.process-icon {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.process-item-text {
  width: 100%;
  padding: 0 10px;
}

.process-name {
  font-size: 16px;
  font-weight: bold;
  color: #000;
  margin-bottom: 10px;
}

.process-desc {
  font-size: 14px;
  color: #666;  padding:  0 50px;
  line-height: 1.6;
  word-break: break-word;
}

.process-arrow {
  font-size: 32px;
  color: #ccc;
  margin-top: 50px;
  flex-shrink: 0;
}

/* 底部导航 */
.footer-nav-section {
  background: #2c2c2c;
  padding: 60px 0;
}

.footer-nav-wrapper {
  display: grid;
  grid-template-columns: 274px 1fr 80px;
  gap: 60px;
  align-items: start;
}

.footer-nav-title {
  color: #fff;
  font-size: 14px;
  margin-bottom: 20px;
}

.footer-nav-list {
  list-style: none;
  line-height: 48px;
}

.footer-nav-list li {
  color: rgba(255, 255, 255, 0.69);
  font-size: 14px;
  cursor: pointer;
}

.footer-contact-info {
  color: #c6c6c6;
  font-size: 14px;
  line-height: 48px;
}

.footer-qr {
  width: 49px;
  height: 50px;
  margin-top: 43px;
  cursor: pointer;
}

/* ========== 响应式设计 ========== */
@media (max-width: 1024px) {
  .banner {
    height: 500px;
  }
  
  .section {
    padding: 40px 0;
  }
  
  .section-label {
    font-size: 28px;
  }
  
  .section-heading {
    font-size: 28px;
    margin-bottom: 35px;
  }
  
  .service-items-grid {
    gap: 30px;
  }
  
  .service-item-img {
    width: 200px;
  }
}

@media (max-width: 768px) {
  .banner {
    height: 300px;
  }
  
  .section {
    padding: 30px 0;
  }
  
  .section-label {
    font-size: 22px;
  }
  
  .section-heading {
    font-size: 22px;
    margin-bottom: 25px;
  }
  
  /* 悦享超级卡 - 移动端 */
  .supercard-wrapper {
    flex-direction: column;
    align-items: center;
  }
  
  .supercard-image {
    flex: none;
    margin-bottom: 20px;
  }
  
  .supercard-image img {
    width: 150px;
  }
  
  .supercard-content {
    text-align: center;
  }
  
  .supercard-title {
    font-size: 16px;
    padding-top: 0;
  }
  
  .supercard-desc {
    font-size: 14px;
    line-height: 1.8;
  }
  
  .supercard-features {
    font-size: 14px;
    line-height: 1.8;
    text-align: left;
  }
  
  .supercard-features h3 {
    font-size: 16px;
  }
  
  /* 服务项目 - 移动端 */
  .service-items-grid {
    flex-direction: column;
    gap: 25px;
  }
  
  .service-item {
    flex-direction: row;
    align-items: center;
    gap: 15px;
    padding: 15px;
    background: #f9f9f9;
    border-radius: 8px;
  }
  
  .service-item-img {
    width: 100px;
    margin: 0;
    flex-shrink: 0;
  }
  
  .service-item-content {
    flex: 1;
    max-width: none;
    text-align: left;
  }
  
  .service-item-name {
    font-size: 16px;
    margin-bottom: 5px;
  }
  
  .service-item-desc {
    font-size: 12px;
    line-height: 1.5;
  }
  
  /* 流程步骤 - 移动端 */
  .process-steps {
    flex-direction: column;
    align-items: center;
    gap: 15px;
  }
  
  .process-item {
    width: 100%;
    max-width: 320px;
    flex-direction: row;
    align-items: center;
    gap: 15px;
    text-align: left;
  }
  
  .process-card {
    width: 70px;
    height: 70px;
    margin: 0;
  }
  
  .process-item-text {
    flex: 1;
    padding: 0;
  }
  
  .process-name {
    font-size: 14px;
    margin-bottom: 5px;
  }
  
  .process-desc {
    font-size: 12px;
    line-height: 1.5;
  }
  
  .process-arrow {
    transform: rotate(90deg);
    margin: 0;
    font-size: 24px;
  }
  
  /* 底部导航 */
  .footer-nav-wrapper {
    grid-template-columns: 1fr;
    gap: 30px;
  }
}

@media (max-width: 480px) {
  .banner {
    height: 200px;
  }
  
  .section-label {
    font-size: 18px;
  }
  
  .section-heading {
    font-size: 20px;
  }
  
  .service-item {
    flex-direction: column;
    text-align: center;
    align-items: center;
  }
  
  .service-item-img {
    width: 80px;
    margin-bottom: 10px;
  }
  
  .service-item-content {
    text-align: center;
  }
  
  .process-item {
    max-width: 100%;
    flex-direction: column;
    text-align: center;
    align-items: center;
  }
  
  .process-card {
    width: 60px;
    height: 60px;
    margin-bottom: 10px;
  }
  
  .process-item-text {
    text-align: center;
  }
}
</style>


// WEBPACK FOOTER //
// src/Cases.vue